import { countTotalAllDivs } from "./countTotal.js";
import { displayMessage, closeToastByTaskId } from "../alert/messageFunc.js";
import { translate, getLanguageUrlPrefix } from "./translations.js";
import { getValidationContainer, validateForm } from "../valid/form.js";
import { prepareTotpQrHtml } from "./totpQr.js";
import { withCsrfToken } from "./csrf.js";
import { totpBackupInput } from './totpBackupInput.js';

$(totpBackupInput);

/**
 * Constructs the localized URL for the payment redirect page
 * @returns {string} The localized URL path
 */
function getLocalizedPaymentRedirectUrl() {
    const urlPrefix = getLanguageUrlPrefix();

    // English is the default language and doesn't use a prefix
    if (urlPrefix === 'en') {
        return '/payments/redirect/';
    }

    return `/${urlPrefix}/payments/redirect/`;
}

$('body').on('click', '.form_for_js_in_div .button_for_js_in_div', function (event) {
    var button = $(this);

    //запрос по этой кнопке ещё не завершился. Одного disabled мало: valid/form.js
    //пересчитывает его на каждый input и успевает снять посреди отправки,
    //после чего клик уходил вторым параллельным POST
    if (button.attr('data-request-pending') === '1') {
        return;
    }

    var button_name = button.attr('name');
    var formdiv = $(this).closest('.form_for_js_in_div');

    //переключатели в профиле (ip_protect, totp_status) это лейбл над радио.
    //Обработчик срабатывает до того, как браузер переключит радио, а для 2FA
    //helpers/totpSwitch.js переключение вообще отменяет до подтверждения кодом.
    //Для тумблеров отправляем противоположное текущему значение с любой половины.
    var clickedRadio = null;
    if (this.tagName === 'LABEL') {
        var labelControl = this.control || (this.htmlFor ? document.getElementById(this.htmlFor) : null);
        if (labelControl && labelControl.type === 'radio') {
            clickedRadio = labelControl;
            if (['ip_protect', 'totp_status'].includes(labelControl.name)) {
                event.preventDefault();
                const radios = Array.from(formdiv[0].querySelectorAll('input[type="radio"]'))
                    .filter(input => input.name === labelControl.name);
                const current = radios.find(input => input.checked);
                clickedRadio = radios.find(input => input.value === (current?.value === '1' ? '0' : '1'));
                if (!clickedRadio) return;
                if (labelControl.name === 'ip_protect') clickedRadio.checked = true;
            }
        }
    }
    var action = formdiv.data('action');
    const backupInput = formdiv[0].querySelector('[data-totp-backup-input]:not(:disabled)');
    if (backupInput && !backupInput.checkValidity()) {
        const invalidCell = formdiv[0].querySelector('[data-totp-backup-part]:invalid');
        if (invalidCell) invalidCell.reportValidity();
        return;
    }
    var shouldOpenInNewTab = !!(formdiv.data('target-blank') || button.data('target-blank'));
    //console.log(action);

    var post_data = {};
    var bet_items = [];

    //add all inputs to post_data
    var inputs = formdiv.find('input');
    //console.log(inputs);
    for (var i = 0; i < inputs.length; i++) {
        const input = inputs.eq(i);
        // Only the active 2FA input mode belongs in the request.
        if (input.prop('disabled') && input.is('input[name="totp_code_parts[]"], [data-totp-backup-input]')) {
            continue;
        }
        if (input.closest('#js_items').length > 0) {
            continue;
        }
        // console.log(input)
        if (input.attr(`type`) == `radio` || input.attr(`type`) == `checkbox`) {
            if (clickedRadio && input.attr('name') === clickedRadio.name) {
                //из группы нажатого переключателя отправляем именно его вариант
                if (input[0] !== clickedRadio) {
                    continue;
                }
            } else if (!input.prop("checked")) {//если не чекед то не отправляем
                continue;
            }
        }

        var inputname = input.attr('name');
        if (inputname == 'undefined' || inputname == undefined) {
            continue;
        }
        var inputvalue = input.val();

        // Handle bet_item[] specially
        if (inputname === 'bet_item[]') {
            bet_items.push(inputvalue);
            continue;
        }

        if (inputname && inputname.includes('[]') && inputname !== 'bet_item[]') {
            if (post_data[inputname] == undefined) {
                post_data[inputname] = [];
            }
            post_data[inputname].push(inputvalue);
        } else {
            post_data[inputname] = inputvalue;
        }
    }

    // Add bet items as JSON
    if (bet_items.length > 0) {
        post_data['bet_items_json'] = JSON.stringify(bet_items);
    }

    //add all selects to post_data
    var selects = formdiv.find('select');
    for (var i = 0; i < selects.length; i++) {
        const select = selects.eq(i);
        var selectname = select.attr('name');
        var selectvalue = select.val();
        if (selectname && selectname.includes('[]')) {
            if (post_data[selectname] == undefined) {
                post_data[selectname] = [];
            }
            post_data[selectname].push(selectvalue);
        } else {
            post_data[selectname] = selectvalue;
        }
    }


    var recaptcha = formdiv.find('textarea.g-recaptcha-response');
    if (recaptcha) {
        post_data['g-recaptcha-response'] = recaptcha.val();
    }
    //var post_data;

    post_data.button_name = button_name;
    // console.log('https://' + window.location.host + action);
    // console.log(post_data);
    //метка живёт до конца запроса. Помечаем кнопку, а не форму: в профиле и
    //обменнике в одном .form_for_js_in_div лежит несколько кнопок, и блокировать
    //соседние на время чужого запроса не надо
    button.attr('data-request-pending', '1');

    //перед отправкой отключаем кнопку и добавляем анимацию лоада
    const isTotpCodeSubmit = ['totp_status_enable', 'totp_check_auth', 'totp_status_disable', 'totp_backup_code_check'].includes(button_name)
        && formdiv.find('input[name="totp_code_parts[]"], [data-totp-backup-input]').length > 0;
    button.prop("disabled", true);
    if (button.hasClass('animation-loading') || isTotpCodeSubmit) {
        button.addClass('loading');
    }
    if (button.hasClass('hide-loading')) {
        button.hide();
    }
    // Pre-open new tab if form/button expects it (must be synchronous in click handler to bypass popup blocker)
    var newTab = null;
    if (shouldOpenInNewTab) {
        const redirectUrl = getLocalizedPaymentRedirectUrl();
        newTab = window.open(redirectUrl, '_blank');
    }

    let url = 'https://' + window.location.host + action;
    //alert(JSON.stringify([url, post_data]));
    var posting = $.post(url, withCsrfToken(url, post_data));
    posting.done(function (data, textStatus, request) {
        try {
            // Display message if available in the initial response
            if (data.message && data.message.text) {
                displayMessage(
                    translate(data.message.text), 
                    data.message.type, 
                    translate(data.message.title),
                    data.message.timeout,
                    data.task_id || null
                );
            }

            if (data.task_id) {
                // Use retry_after and retry_count if available, otherwise use default values
                const retryInterval = data.retry_after ? data.retry_after * 1000 : 5000;
                const maxRetries = data.retry_count || 10;
                
                if (data.content_html) {
                    $('body').append(prepareTotpQrHtml(data.content_html));
                }
                // Schedule the first poll after retryInterval
                setTimeout(() => {
                    pollTaskStatus(data.task_id, formdiv, button, action, post_data, 0, maxRetries, retryInterval);
                }, retryInterval);
            } else {
                handleResponse(data, action, formdiv, post_data, button);
                cleanup();
            }
        } catch (error) {
            console.error(error);
            if (newTab) newTab.close();
            cleanup();
        }
    });

    posting.fail(function (jqXHR, textStatus, error) {
        console.error(`error posting`, action);
        console.error(jqXHR, textStatus, error);
        if (newTab) newTab.close();
        $('.response_block_close_js_answer').remove();
        $('div.blackout').remove();
        try {
            // Release the submitted OTP state on HTTP, network and JSON parse errors too.
            dispatchFormResponse({}, action, formdiv);
        } finally {
            cleanupAfterFailure();
        }
    })


    function pollTaskStatus(taskId, formdiv, button, action, post_data, retryCount = 0, maxRetries = 10, retryInterval = 5000) {
        const pollUrl = `https://${window.location.host}/engine/function/long_running_process.php?task_id=${taskId}`;

        $.get(pollUrl)
            .done(function (response) {
                if (response.message && response.message.text) {
                    displayMessage(
                        translate(response.message.text), 
                        response.message.type, 
                        translate(response.message.title),
                        response.message.timeout,
                        taskId
                    );
                }

                const currentMaxRetries = response.retry_count || maxRetries;
                const currentRetryInterval = response.retry_after ? response.retry_after * 1000 : retryInterval;

                if (response.status === 'completed') {
                    try {
                        closeToastByTaskId(taskId);
                        handleResponse(response, action, formdiv, post_data, button);
                    } catch (error) {
                        console.error(error);
                        if (newTab) newTab.close();
                    } finally {
                        cleanup();
                    }
                } else if (response.status === 'processing') {
                    // Only handle processing status for radiation requests
                    if (action === '/engine/function/items_exchanger/post_items_exchanger.php' && 
                        post_data.button_name === 'rand_exchanges') {
                        // Call handleResponse for progressive radiation
                        handleResponse(response, action, formdiv, post_data, button);
                    }
                    
                    // Continue polling if within retry limit
                    if (retryCount < currentMaxRetries) {
                        setTimeout(() => pollTaskStatus(taskId, formdiv, button, action, post_data, retryCount + 1, currentMaxRetries, currentRetryInterval), currentRetryInterval);
                    } else {
                        console.log('Maximum retries reached for processing task', taskId);
                        
                        finishPollingFailure();
                    }
                } else if (response.status === 'error' && retryCount < currentMaxRetries) {
                    setTimeout(() => pollTaskStatus(taskId, formdiv, button, action, post_data, retryCount + 1, currentMaxRetries, currentRetryInterval), currentRetryInterval);
                } else {
                    console.log('Task not found or maximum retries reached', taskId);
                    finishPollingFailure();
                }
            })
            .fail(function (jqXHR, textStatus, error) {
                console.error(`Error polling`, pollUrl, error);
                if (retryCount < maxRetries) {
                    // Retry on failure if within retry limit
                    setTimeout(() => pollTaskStatus(taskId, formdiv, button, action, post_data, retryCount + 1, maxRetries, retryInterval), retryInterval);
                } else {
                    console.error(`max retries reached for task ${taskId}`);
                    
                    finishPollingFailure();
                }
            });
    }

    function cleanupAfterFailure() {
        try {
            cleanup();
        } finally {
            // Document still receives the failure if the submitted modal was removed.
            document.dispatchEvent(new CustomEvent('js-form:request-failed', {
                detail: {action, buttonName: button_name, form: formdiv[0]}
            }));
        }
    }

    function finishPollingFailure() {
        try {
            if (action === '/engine/function/items_exchanger/post_items_exchanger.php' &&
                post_data.button_name === 'rand_exchanges') {
                handleResponse({status: 'error'}, action, formdiv, post_data, button);
            } else {
                dispatchFormResponse({}, action, formdiv);
            }
            displayMessage(translate('Error sending request'), 'error', translate('Error'));
        } catch (error) {
            console.error(error);
            if (newTab) newTab.close();
        } finally {
            cleanupAfterFailure();
        }
    }

    function cleanup() {
        toSVG();
        button.removeAttr('data-request-pending');
        // Skip cleanup for radiate buttons - let items-reactor handle it
        if (action === '/engine/function/items_exchanger/post_items_exchanger.php' && post_data.button_name === 'rand_exchanges') {
            return;
        }
        button.prop("disabled", false);
        button.removeClass('loading');
        button.find('.loading-div__mini_b').remove();
        refreshValidationState();
        }

    //ответ мог очистить обязательные поля, например код 2FA после неверного ввода.
    //Без пересчёта кнопка остаётся включённой и уходит отправка с пустыми полями
    function refreshValidationState() {
        const submittedButton = button[0];
        const container = getValidationContainer(submittedButton);
        // Match input validation: it only refreshes the first impacted button.
        // Disabling another button here would leave it disabled after refilling.
        if (container?.querySelector('.input-necessarily')) {
            validateForm(container);
        }
    }


    function dispatchFormResponse(data, action, formdiv, responseNode = null, responseNodes = []) {
        // Ответ адресован только отправленной форме, включая ветку data.error.
        if (formdiv[0]) {
            formdiv[0].dispatchEvent(new CustomEvent('js-form:response', {
                bubbles: true,
                detail: {action: action, data: data, responseNode: responseNode, responseNodes: responseNodes}
            }));
        }
    }

    function handleResponse(data, action, formdiv, post_data, button) {
        if (data.error) {
            if (newTab && !newTab.closed) {
                newTab.close();
            }
            $('body').append(prepareTotpQrHtml(data.error));
            dispatchFormResponse(data, action, formdiv);
            return;
        }

        $('.response_block_close_js_answer').remove();
        $('div.blackout').remove();

        var responseNode = null;
        var responseNodes = [];
        if (data.content_html) {
            // Parse as content, never as a selector. Keep legacy script execution.
            var $responseNodes = $($.parseHTML(prepareTotpQrHtml(data.content_html), document, true));
            $('body').append($responseNodes);
            responseNodes = $responseNodes.get().filter(function (node) {
                return node.nodeType === 1;
            });
            // Keep the legacy field, but let consumers inspect every live root.
            responseNode = responseNodes[0] || null;
        }

        dispatchFormResponse(data, action, formdiv, responseNode, responseNodes);

        // Check for custom radiate response handler
        if (typeof window.handleRadiateResponse === 'function') {
            if (window.handleRadiateResponse(data, action, formdiv, post_data, button)) {
                return; // Custom handler processed the response
            }
        }


        if (action == '/engine/function/user_trades_post.php') {
            if (formdiv.hasClass('modal') && post_data.trade_type == 'sell') {
                if (data.response && data.response.trade) {
                    $('#js__sell_up').closest('.bet-content').show();
                    //foreach assetidd from post_data['items_arr[]] remove all items with this assetid
                    $.each(post_data['items_arr[]'], function(index, assetid) {
                        $(`input[name=assetid][value=${assetid}]`).closest('.pay__item.setting').remove();
                    });
                    //$(`input[name=assetid][value=${post_data.assetid}]`).closest('.pay__item.setting').remove();
                    $('#js__sell_up').find('.bet-content-show').first().append(data.response.trade);
                    formdiv.find('a.js-close')[0].click();
                    countTotalAllDivs();
                    return;
                } else {
                    return;
                }
            }

            if (formdiv.hasClass('modal') || post_data['cancel_item_selling']) {
                if (!data.response) {
                    return;
                }
                if (!data.response.user_trade_id) {
                    return;
                }
                if (!data.response.price) {
                    $(`input[value="${data.response.user_trade_id}"]`).closest('.pay__item.setting').remove();
                    formdiv.find('a.js-close')[0].click();
                    countTotalAllDivs();
                    return;
                }
                let $item_div = $(`input[value="${data.response.user_trade_id}"]`).closest('.pay__item.setting');
                $item_div.find('[data-price]').data('price', data.response.price);
                $item_div.find('.pay__item-sum .money-amount .js_amount').text(data.response.price);
                formdiv.find('a.js-close')[0].click();
                countTotalAllDivs();
                return;
            }
        }

        if (action.includes('/engine/function/give_achievement_bonus.php')) {
            formdiv.find('.js_response_to_div').html(data);
            return;
        }

        if (data.response && data.response.return_url) {
            if (shouldOpenInNewTab && data.response.return_new_tab && newTab) {
                newTab.location.href = data.response.return_url;
            } else if (shouldOpenInNewTab && data.response.return_new_tab && !newTab) {
                // Fallback: try programmatic link when the pre-opened tab was blocked.
                var a = document.createElement('a');
                a.href = data.response.return_url;
                a.target = '_blank';
                a.rel = 'noopener noreferrer';
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.location.assign(data.response.return_url);
            } else {
                if (newTab && !newTab.closed) newTab.close();
                window.location.assign(data.response.return_url);
            }
            return;
        }

        if (newTab && !newTab.closed) {
            newTab.close();
        }


    }


    if ($(this).hasClass('response_block_close_js')) {
        //console.log('closing by class');
        $('div.blackout').remove();
        formdiv.remove();
        return;
    }
});
